import { config } from "./config";

export const userApi = config.BASE_API + "user";
export const homeApi = config.BASE_API + "home";
export const localApi = config.BASE_API + "local";
